<template>
  <button
    @mouseover="hovered = true"
    @mouseleave="hovered = false"
    class="inline-flex justify-center items-center focus:outline-none py-2 px-3 text-1xl w-full transition duration-200 ease-in-out uppercase"
    :class="customCss"
    :disabled="disabled"
    :type="type"
    @click="$emit('onClick')"
  >
    <slot>
      CustomButton
    </slot>
  </button>
</template>

<script>
export default {
  name: 'CustomButtmFives',
  props: {
    type: {
      type: String,
      default: 'button'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    },
    bgColor: String
  },
  data () {
    return {
      hovered: false
    }
  },
  computed: {
    customCss: function () {
      var toReturn = ''
      toReturn += ' opacity-100 '

      if (this.dark) toReturn += ' text-white '
      else toReturn += ' text-black '

      if (this.bgColor) toReturn += this.bgColor
      else {
        if (this.dark) toReturn += ' bg-black '
        else toReturn += ' bg-white '
      }

      toReturn += ' font-normal '

      if (!this.disabled) {
        toReturn += ' hover:font-semibold '
      } else {
        toReturn += ' cursor-default '
      }
      return toReturn
    }
  }
}
</script>
